import * as Collapsible from '@/components/ui/collapsible'
import { IconButton } from '@/components/ui/icon-button'
import { ChevronsUpDown } from 'lucide-solid'
import type { JSX, ParentProps } from 'solid-js'
import { Box, Flex } from 'styled-system/jsx'

export const AppCollapsible = (
  props: ParentProps<Collapsible.RootProps & { headerContent: JSX.Element, hideBorder?: boolean }>,
) => {
  return (
    <Collapsible.Root
      {...props}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        width='100%'
        px='3'
        borderBottom={props.hideBorder ? 'none' : 'solid 1px'}
        borderColor='bg.subtle!'
      >
        {props.headerContent}
        <Collapsible.Trigger
          asChild={(triggerProps) => (
            <IconButton
              size='xs'
              {...triggerProps()}
              variant="plain"
            >
              <ChevronsUpDown />
            </IconButton>
          )}
        />
      </Flex>
      <Collapsible.Content>
        <Box
          bg="colorPalette.default"
          color="colorPalette.fg"
          borderRadius="l3"
        >
          {props.children}
        </Box>
      </Collapsible.Content>
    </Collapsible.Root>
  )
}
